@if (get(valuePropsRow, 'value_props', false)) {
  <section [class.gray-bg]="get(valuePropsRow, 'value_props.gray_background')">
    <div class="container grid partial-grid">
      @for (props of get(valuePropsRow, 'value_props.value_prop_set', []); track props) {
        <div
          class="content g-col-sm-4 g-col-12 d-flex flex-column align-items-center"
          >
          <span class="value-prop-icon" [style.--icon-url]="getIconUrl(get(props, 'value_prop[0].icon.href', ''))"></span>
          <h4 class="old text-center">{{ get(props, 'value_prop[0].value_prop_title', '') }}</h4>
          <p>{{ get(props, 'value_prop[0].value_prop_description', '') }}</p>
        </div>
      }
    </div>
  </section>
}
@if (get(valuePropsRow, 'value_props.split_line', '')) {
  <hr class="m-0 mb-3" />
}
